import { render, staticRenderFns } from "./journal-soins-realises.vue?vue&type=template&id=4544057a&scoped=true"
import script from "./journal-soins-realises.vue?vue&type=script&lang=js"
export * from "./journal-soins-realises.vue?vue&type=script&lang=js"
import style0 from "./journal-soins-realises.vue?vue&type=style&index=0&id=4544057a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4544057a",
  null
  
)

export default component.exports